export const themeColors = {
  background: {
    navyDark: 'rgb(6, 8, 9)',
    navy: 'rgb(8, 14, 24)',
    navyLight: 'rgb(13, 19, 34)',
    navyLighter: 'rgb(16, 24, 42)',
    navyLightest: 'rgb(23, 33, 56)',
  },
  border: {
    navy: 'rgb(33, 41, 57)',
    green: '#8bfcb6',
  },
  boxShadow: {
    focus: '0 0 8px rgba(139, 252, 182, 0.8)',
    primary: '0 12px 30px rgba(0, 0, 0, 0.4)',
  },
  text: {
    light: 'rgb(232, 236, 245)',
    regular: 'rgb(192, 200, 212)',
    dark: 'rgb(131, 145, 174)',
  },
  transition: {
    150: '0.15s ease-in-out',
  },
  icon: {
    xs: '16px',
    sm: '20px',
  },
  primary: '#8bfcb6',
  secondary: '#85f98bff',
  error: '#e54c91',
} as const;
